import { Module } from 'vuex';
import { getters } from './getters';
import { actions } from './actions';
import { mutations } from './mutations';
import { Clients } from './types';
import { RootState } from '../types';

export const state: Clients = {
  clients: [],
  pages: 1,
  clientsViewType: 'grid',
};

export const client: Module<Clients, RootState> = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
